module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.9-267.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.7.9.md
// module id = 710
// module chunks = 234